import { v4 as uuidv4 } from 'uuid';
import { API_URLS, getApiUrl } from '../api/Utils/apiURLConfiguration';
import { LocalStorageKeys } from '../utilities/storageUtils';
import DocumentStoreRepository from './DocumentStoreRepository';

const listLength = 10;

export default class RecentSearchesRepository extends DocumentStoreRepository {
  constructor() {
    let urlAux = getApiUrl(API_URLS.REACT_APP_RECENT_SEARCHES_SERVICE_ENDPOINT, 'v1');
    let completeUrl = `${urlAux}/profiles/webusers/recent-searches`;

    super(completeUrl, LocalStorageKeys.RecentSearches);
  }

  async setRecentSearch(recentSearchData) {
    if (!this.apiClient.isLoggedIn) {
      super.set(recentSearchData);
    }
  }

  async getAllRecentSearches() {
    return super.getAll();
  }

  async addNewRecentSearch(recentSearchesList, recentSearchData) {
    let recentSearchGuuid = uuidv4();

    try {
      let recentSearchToAdd = {
        ...recentSearchData,
        id: recentSearchGuuid,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };

      // If something fails then we don't mess up with the current recentSearchesList.
      // Get the first 9 elements
      let recentSearchesListClone = recentSearchesList.slice(0, listLength - 1);

      // add element at the top of the array
      recentSearchesListClone.unshift(recentSearchToAdd);

      await this.setRecentSearch(recentSearchesListClone);

      return recentSearchesListClone;
    } catch {
      throw new Error('Error adding the recent search');
    }
  }

  async updateRecentSearch(recentSearchesList, recentSearchData) {
    try {
      let foundIndex = recentSearchesList.findIndex(x => x.id === recentSearchData.id);
      recentSearchesList[foundIndex] = recentSearchData;

      await this.setRecentSearch(recentSearchesList);

      return recentSearchesList;
    } catch {
      throw new Error('Error on update the recent search');
    }
  }

  async deleteRecentSearchById(recentSearchesList, recentSearchId) {
    let filteredRecentSearches = recentSearchesList.filter(x => x.id !== recentSearchId);

    await this.setRecentSearch(filteredRecentSearches);

    return filteredRecentSearches;
  }
}
